import {makeStyles} from "tss-react/mui";

export const usePickerStyles = makeStyles()((theme, {color}) => ({
  rootMargin: {
    margin: ".5rem .5rem 1.5rem .5rem",
  },
  containerWidth: {
    width: theme.spacing(27.5),
  },
  picker: {
    background: `${theme.palette.draggable.accent} !important`,
    borderRadius: "0 !important",
    boxShadow: `${theme.palette.draggable.accent} 0px 3px 11px !important`,
    "& label": {
      color: `${theme.palette.primary.main} !important`,
    },
  },
  pickerChip: {
    backgroundColor: color ?? "inherit",
    width: "100%",
    border: "1px dashed gray",
    marginBottom: "0.25rem",
  },
}));

export const useColorsWithPreviewStyles = makeStyles()((theme) => ({
  previewField: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  preview: {
    display: "flex",
    flexWrap: "wrap",
  },
}));

export const useListStyles = makeStyles()((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 360,
  },
}));

export const useListItemStyles = makeStyles()((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.draggable.accent,
    justifyContent: "space-between",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      "& div": {},
      "& p": {
        color: theme.palette.background.default,
      },
    },
  },
  end: {
    width: "100%",
    backgroundColor: theme.palette.draggable.end,
    justifyContent: "center",
  },
  scenarioHeader: {
    width: "100%",
    backgroundColor: "#6000B0",
    justifyContent: "center",
  },
  scenarioHeaderText: {
    color: "#FFFFFF",
  },
  selected: {
    backgroundColor: `${theme.palette.draggable.selected} !important`,
  },
}));

export const useGridHeaderStyles = makeStyles()((theme) => ({
  selectedSchema: {
    minWidth: theme.spacing(12),
    marginBottom: theme.spacing(1),
    background: theme.palette.tabs.background,
  },
  headerButtonLeft: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(0.5),
  },
  headerButton: {
    marginTop: theme.spacing(0.5),
  },
}));

export const useSchemaFieldStyles = makeStyles()((theme) => ({
  marginTop: {
    marginTop: theme.spacing(1),
  },
  schemaListItem: {
    borderBottom: `1px solid ${theme.palette.text.primary}`,
    marginTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}));
